// extracted by mini-css-extract-plugin
export default {"danger":"UserRegistrationForm_danger__e5SCG","select":"UserRegistrationForm_select__u3p-i"};